import React from "react"
import { css } from "styled-components"
import Spacer from "../../../design-system/atoms/layout-primitives/spacer"
import VariantContainer from "../../../design-system/atoms/variant-container"
import Breakpoints from "../breakpoints"
import Grid from "../grid"
import LayerFeatureList from "./mappedin-layers.featurelist"

export default function MappedinLayersGraphiclist({ assets }) {
  const { layersSvgLg, layersSvgMd, iconLayer1, iconLayer2 } = assets

  return (
    <>
      <Spacer height={{ sm: "48px", md: "64px", lg: "0" }} />
      <Grid>
        <VariantContainer
          variants={[
            css`
              display: none;
            `,
            css`
              display: block;
              grid-column: 1 / -1;
              justify-self: center;
            `,
          ]}
        >
          <picture>
            <source
              media={`(min-width: ${Breakpoints.lg})`}
              srcSet={layersSvgLg.publicURL}
            />
            <img src={layersSvgMd.publicURL} style={{ maxWidth: "100%" }} />
          </picture>
        </VariantContainer>
        <LayerFeatureList
          logoSrc={iconLayer1.publicURL}
          logoAlt='An icon showing rectangular layers stacked on top of each other next to the text "Layer 1'
          title="Digital Foundation"
          description="Delivered through Mappedin's enterprise-grade CMS."
          color={"var(--burnt-orange)"}
        >
          <li>Automated Map Digitization</li>
          <li>Map Editor</li>
          <li>Data Management</li>
        </LayerFeatureList>
      </Grid>
      <Spacer height={{ sm: "48px", md: "0" }} />
      <Grid>
        <LayerFeatureList
          logoSrc={iconLayer2.publicURL}
          logoAlt='An icon showing rectangular layers stacked on top of each other next to the text "Layer 2'
          title="Developer Tools"
          description="Delivered through SDKs, exports, and syncs."
        >
          <li>Web SDK</li>
          <li>Mobile SDK</li>
          <li>MVF Export</li>
          <li>IMDF Export</li>
          <li>Analytics API</li>
          <li>Directions API</li>
        </LayerFeatureList>
      </Grid>
      <Spacer height={{ sm: "48px", md: "64px", lg: "96px" }} />
    </>
  )
}
